import { render, staticRenderFns } from "./KnowledgeBaseCard.vue?vue&type=template&id=2c28d5b1&scoped=true&"
import script from "./KnowledgeBaseCard.vue?vue&type=script&lang=js&"
export * from "./KnowledgeBaseCard.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeBaseCard.vue?vue&type=style&index=0&id=2c28d5b1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c28d5b1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
